export const HttpMethod = {
  Get: "GET",
  Post: "POST",
  Put: "PUT",
  Patch: "PATCH",
  Delete: "DELETE",
};

const ApiRoutes = {
  Dashboard: {
    DashboardData: {
      Endpoint: "user/admin/dashboard",
      Method: HttpMethod.Get,
    },
    SuperData: {
      Endpoint: "dashboard/get-superadmin-dashboard",
      Method: HttpMethod.Post,
    },
  },
  Auth: {
    Login: {
      Endpoint: "user/admin/login",
      Method: HttpMethod.Post,
    },
    SignUp: {
      Endpoint: "auth/sign-Up",
      Method: HttpMethod.Post,
    },
    ForgetPassword: {
      Endpoint: "auth/forget-password",
      Method: HttpMethod.Post,
    },
    ResetPassword: {
      Endpoint: "auth/reset-password",
      Method: HttpMethod.Post,
    },
     VerifyOtp: {
      Endpoint: "auth/verify-otp",
      Method: HttpMethod.Post,
    },
    ResendOtp: {
      Endpoint: "auth/resend-otp",
      Method: HttpMethod.Post,
    },
  },
  Upload: {
    UploadMedia: {
      Endpoint: "upload",
      Method: HttpMethod.Post,
    },
  },
  Properties: {
    AllProperties: {
      Endpoint: "user/admin/properties",
      Method: HttpMethod.Get,
    },
    GetPropertyDetails: {
      Endpoint: (propertyId) => `user/property/${propertyId}/details-internal`,
      Method: HttpMethod.Get,
    },
    GetPropertyReports: {
      Endpoint: "user/report/get-property-reports",
      Method: HttpMethod.Get,
    },
    UpdatePropertyReportStatus: {
      Endpoint: "user/report/update-status",
      Method: HttpMethod.Put,
    },
    ToggleBlockProperty: {
      Endpoint: (propertyId) => `user/admin/toggle-block/${propertyId}`,
      Method: HttpMethod.Put,
    },
    DeletePropertyByAdmin: {
      Endpoint: (propertyId) => `user/admin/admin-delete-property/${propertyId}`,
      Method: HttpMethod.Delete,
    },

  },
  User: {
    AllUsers: {
      Endpoint: "user/admin/users",
      Method: HttpMethod.Get,
    },
    UserById: {
      Endpoint: "user/get-user-by-id",
      Method: HttpMethod.Post,
    },

     AddUserNote: {
      Endpoint: "user/admin/user-note-by-admin",
      Method: HttpMethod.Put,
    },

    UserEnquiry: {
      Endpoint: "enquiry/user-enquiries",
      Method: HttpMethod.Get,
    },
    GetUserReports: {
      Endpoint: "user/report/get-user-reports",
      Method: HttpMethod.Get,
    },
    UpdateUserReportStatus: {
      Endpoint: "user/report/update-user-status",
      Method: HttpMethod.Put,
    },
    ToggleBlockUser: {
      Endpoint: (userId) => `user/admin/toggle-user-block/${userId}`,
      Method: HttpMethod.Put,
    },

    SearchPeopleDetail: {
      Endpoint: "/user/profile/search-by-admin/details",
      Method: HttpMethod.Get,
    },
    UsersSummary: {
      Endpoint: "/user/admin/users/summary",
      Method: HttpMethod.Get,
    },
    UserFeatureAccess: {
      Endpoint: "/user/admin/feature-access",
      Method: HttpMethod.Get,
    },
    UserDaily: {
      Endpoint: (userId) => `/user/admin/user/${userId}/daily`,
      Method: HttpMethod.Get,
    },
    UserPages: {
      Endpoint: (userId) => `/user/admin/user/${userId}/pages`,
      Method: HttpMethod.Get,
    },
    UserStats: {
      Endpoint: (data) =>
        `lesson/lesson-response/${data.lessonId}?userId=${data.userId}`,
      Method: HttpMethod.Get,
    },
    AdminTenantRatingSummary: {
      Endpoint: (tenantId) => `rating/admin/summary/${tenantId}`,
      Method: HttpMethod.Get,
    },
    AdminTenantRatingEvents: {
      Endpoint: (tenantId) => `rating/admin/events/${tenantId}`,
      Method: HttpMethod.Get,
    },
  },
  CouponDiscount: {
    CreateCoupon: {
      Endpoint: "user/admin/create-coupon",
      Method: HttpMethod.Post,
    },
    UpdateCoupon: {
      Endpoint: (couponId) => `user/admin/update-coupon/${couponId}`,
      Method: HttpMethod.Put,
    },
    GetAllCoupons: {
      Endpoint: "user/admin/get-all-coupons",
      Method: HttpMethod.Get,
    },
    DeleteCoupon: {
      Endpoint: (couponId) => `user/admin/delete-coupon/${couponId}`,
      Method: HttpMethod.Delete,
    },

  },
};

export default ApiRoutes;
